import { render, staticRenderFns } from "./CardPickupQuickView.vue?vue&type=template&id=b81d87c6&scoped=true"
import script from "./CardPickupQuickView.vue?vue&type=script&lang=js"
export * from "./CardPickupQuickView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81d87c6",
  null
  
)

export default component.exports